import { useState } from "react";
import { goToCameraSnap } from "../service/router";
import { useNavigate } from "react-router-dom";
import CameraSnap from "../components/camera/CameraSnap";

function Camera() {
  const navigate = useNavigate();

  let [images,setImages] = useState([])
  const [isCameraOpen,setCameraOpen] = useState(false)

  function snapPhoto(){
    setCameraOpen(true)
  }

  function saveImage(base64){
    console.log('---',base64)
    setCameraOpen(false)
    setImages([{src:base64,id:new Date().getTime()},...images])
  }

  return (
    <div className="flex flex-col items-center justify-start bg-blue-100 h-screen">

          {
            isCameraOpen &&
            <CameraSnap saveImage={saveImage}/>
          }

          {
            !isCameraOpen &&
            <>
              <div className="flex flex-wrap">
                {
                  images.map((image)=>{
                    return(
                      <div key={image.id} className="w-1/3 max-w-1/3"><img className="p-2" src={image.src}></img></div>
                    )
                  })
                }
              </div>
              <div className="flex flex-row w-full items-center justify-center">
                <div className="w-1/2 text-center font-medium uppercase p-2 m-4 border border-indigo-300" onClick={snapPhoto}>Scatta Foto</div>
              </div>
            </>
          }
          

    </div>
  )
}
  
export default Camera;
  